import unescape from 'lodash/unescape';

import { SOCIAL_NETWORKS } from '~/constants';

import type { ClanInfoType } from '~/Actions/ActionClanProfile';

import type { IClanEditDescription } from '~/Reducers/ReducerClanEdit';

export const addProtocol = (url: string) => {
  const regex = /^(http(s)?:\/\/)/;

  if (!regex.test(url)) {
    return `https://${url}`;
  } else {
    return url;
  }
};

export const parseDescriptionEditError = (data?: IClanEditDescription) => {
  const error: string | null = null;
  const socialsError: boolean | null = null;
  const isValidationError = Boolean(data?.isValidationError);

  const err = data?.error;

  if (typeof err === 'string') {
    return { error: err, socialsError, isValidationError };
  }

  if (!err || typeof err !== 'object') {
    return { error, socialsError, isValidationError };
  }

  if ('socials_error' in err && err.socials_error) {
    return { error, socialsError: true, isValidationError };
  }

  if ('description' in err) {
    const desc = err.description;

    if (typeof desc === 'object' && desc && 'reason' in desc && typeof desc.reason === 'string') {
      return { error: desc.reason, socialsError, isValidationError };
    }

    if (Array.isArray(desc) && typeof desc[0] === 'string') {
      return { error: desc[0], socialsError, isValidationError };
    }
  }

  if ('message' in err && typeof err.message === 'string') {
    return { error: err.message, socialsError, isValidationError: false };
  }

  return { error, socialsError, isValidationError: false };
};

export const getNormalizedDescription = (description: string) => {
  return unescape(description.trim()).replace(/(\r\n|\n|\t|\r){3,}/g, '\n\n');
};

type IPreparedClanSocials = Partial<
  Record<
    SOCIAL_NETWORKS,
    {
      link: string;
      error: boolean;
    }
  >
>;

export const prepareClanSocials = (communityUrls: ClanInfoType['communityUrls']): IPreparedClanSocials => {
  return Object.keys(SOCIAL_NETWORKS).reduce((acc, socialName) => {
    if (communityUrls?.[SOCIAL_NETWORKS[socialName] as SOCIAL_NETWORKS]) {
      return {
        ...acc,
        [SOCIAL_NETWORKS[socialName]]: {
          link: communityUrls[SOCIAL_NETWORKS[socialName] as SOCIAL_NETWORKS],
          error: false,
        },
      };
    }
    return acc;
  }, {});
};
